import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    title: "1. Общие положения",
    paragraphs: [
      "Настоящая Политика обработки персональных данных действует в отношении всей информации, размещенной на канал-боте «@freshcasting_bot» в Telegram. Любое пользование Ботом означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки его персональных данных.",
      "1.1. Настоящая Политика определяет порядок сбора, хранения, использования, распространения и защиты персональных данных, предоставляемых Пользователем при использовании Telegram-бота @freshcasting_bot и закрытого Telegram-канала.",
      "1.2. Исполнитель - Индивидуальный предприниматель СКОРЯБКИНА АЛЕКСАНДРА ВАЛЕРЬЕВНА, ИНН 781602232900, ОГРНИП 325784700307756 - действует в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».",
      "1.3. Использование Сервиса, в том числе регистрация, акцепт оферты и оплата подписки, означает согласие Пользователя на обработку его персональных данных в соответствии с настоящей Политикой.",
    ],
  },
  {
    title: "2. Основные понятия",
    paragraphs: ["2.1. Персональные данные - любая информация, относящаяся к физическому лицу (субъекту персональных данных).", "2.2. Обработка персональных данных - действия с данными, включая сбор, систематизацию, хранение, использование, передачу и уничтожение в целях исполнения обязательств по Договору."],
  },
  {
    title: "3. Цели обработки данных",
    paragraphs: ["3.1. Обработка персональных данных осуществляется для исполнения обязательств по Договору публичной оферты, предоставления доступа к закрытому Telegram-каналу с кастингами, взаимодействия с Пользователем, технической поддержки, анализа использования Сервиса и улучшения качества услуг."],
  },
  {
    title: "4. Объём обрабатываемых данных",
    paragraphs: [
      "4.1. В рамках Сервиса Исполнитель обрабатывает следующие категории персональных данных: имя, фамилия, номер телефона, адрес электронной почты (если предоставлен), данные, переданные при оформлении подписки через Telegram-бот или платёжную систему, иные данные, которые Пользователь добровольно предоставляет через формы в боте.",
      "4.2. Дополнительные данные детей, если предоставляются родителем, обрабатываются только для целей участия в кастинг-предложениях, сохранения профиля и передачи в случае необходимости организаторам кастингов при отдельном согласии родителей.",
    ],
  },
  {
    title: "5. Правовые основания обработки",
    paragraphs: ["5.1. Обработка данных осуществляется на основании согласия Пользователя, выраженного акцептом настоящей Политики, выполнения обязательств по Договору публичной оферты и требований законодательства РФ."],
  },
  {
    title: "6. Порядок и условия обработки",
    paragraphs: [
      "6.1. Персональные данные обрабатываются законными и добросовестными способами с применением правовых, организационных и технических мер для защиты от несанкционированного доступа, утраты, изменения или распространения.",
      "6.2. Доступ к персональным данным имеют только уполномоченные сотрудники Исполнителя.",
      "6.3. Передача персональных данных третьим лицам осуществляется только в случаях, прямо предусмотренных Политикой, для исполнения обязательств по Договору или по запросу уполномоченных государственных органов в порядке, установленном законодательством.",
    ],
  },
  {
    title: "7. Срок хранения данных",
    paragraphs: ["7.1. Персональные данные хранятся не дольше, чем требуется для целей обработки, указанных в настоящей Политике, либо пока иное не установлено законодательством РФ.", "7.2. После достижения целей обработки данные подлежат обезличиванию или уничтожению в соответствии с внутренними правилами Исполнителя."],
  },
  {
    title: "8. Права субъекта персональных данных",
    paragraphs: ["8.1. Пользователь имеет право получать информацию об обработке своих данных, требовать уточнения, блокировки или удаления данных в случаях, предусмотренных Законом, а также отзывать согласие на обработку персональных данных.", "8.2. Отзыв согласия осуществляется путем направления письменного заявления на контактные данные Исполнителя."],
  },
  {
    title: "9. Ответственность за нарушение правил обработки",
    paragraphs: ["9.1. Исполнитель принимает необходимые меры для защиты данных.", "9.2. Пользователь несёт ответственность за достоверность предоставляемых данных."],
  },
  {
    title: "10. Изменение Политики",
    paragraphs: ["10.1. Исполнитель вправе в любое время вносить изменения в настоящую Политику, которые вступают в силу с момента публикации по постоянной ссылке.", "10.2. Действующая Политика размещена на странице по адресу: https://disk.yandex.ru/d/7PA_Eu1mnj8ICA"],
  },
  {
    title: "11. Контактная информация",
    paragraphs: ["Запросы по обработке персональных данных направляются на электронную почту или Telegram-аккаунт Исполнителя: Telegram: t.me/kastingi_deti"],
  },
];

const PrivacyPage = () => <LegalPage title="Политика обработки персональных данных" sections={sections} />;

export default PrivacyPage;
